const populateSubscriberKey = (subscriberKey, emailAddress) => {
  const subscriberKeyIsNull = subscriberKey === null;
  const subscriberKeyIsEmpty = subscriberKey === '';
  const subscriberKeyIsUndefined = subscriberKey === undefined;
  const subscriberKeyIsInvalid = subscriberKeyIsNull || subscriberKeyIsEmpty || subscriberKeyIsUndefined;

  // return email address in place of subscriber key as SFMC requires this field to be non-null
  if (subscriberKeyIsInvalid) {
    console.log(`Subscriber ID not present. Using the provided email address ${emailAddress} as Subscriber Key.`);
    return emailAddress;
  }
  console.log(`suscriberKey ${subscriberKey} is present`);
  return subscriberKey;
};

const CALCULATE_CLICK_EVENT = new Event('calculate-click');

const dispatchCalculateEvent = () => {
  document.dispatchEvent(CALCULATE_CLICK_EVENT);
}

export {
  populateSubscriberKey,
  dispatchCalculateEvent
};
